<template>
	<div class="Videopublicity">
		<div class="Videopublicity-top">
			<div class="Videopublicity-top-img">
				<img
					:src="require('@/assets/images/Companycultrue-top.png')"
					class="image-width"
					alt=""
				/>
			</div>
		</div>
		<div class="Videopublicity-mid-out">
			<div class="Videopublicity-mid">
				<img
					:src="require('@/assets/images/Videopublicity-mid.png')"
					class="image-width"
					alt=""
				/>
			</div>
			<div class="Videopublicity-mid-text">{{ $t('视频宣传') }}</div>
		</div>
		<div class="Videopublicity-box">
			<div
				class="Videopublicity-box-item"
				v-for="(item, index) in videolist"
				:key="index"
			>
				<div class="box-item-img">
					<VideoBox
						ref="videoPlayer"
						:poster="lang === 'en' ? item.iconEn : item.iconSJ"
						:videoSrc="item.url"
						@click.native="playVideo(item, index)"
					/>
				</div>
				<div class="box-item-text">
					{{ getLangText(item, 'name') }}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { getVideoList } from '@/api';
import VideoBox from '@/components/VideoBox/index.vue';
export default {
	components: {
		VideoBox
	},
	data() {
		return {
			videolist: []
		};
	},
	created() {
		this.frontListFZ();
	},
	methods: {
		//业务图片接口
		frontListFZ() {
			let params = {
				type: 3,
				language: Number(this.lang === 'en')
			};
			getVideoList(params).then(res => {
				this.videolist = res.list.map(it => ({
					...it,
					isPlaying: false
				}));
			});
		},
		//点击播放视频
		playVideo(item, i) {
			if (!item.isPlaying) {
				this.$refs.videoPlayer[i].play();
				item.isPlaying = true;
			} else {
				this.$refs.videoPlayer[i].pause();
				item.isPlaying = false;
			}
		}
	}
};
</script>

<style lang="scss">
@use './Videopublicity.scss';
</style>
